// extracted by mini-css-extract-plugin
export default {"container_full":"ComplianceMemo_container_full__R2Dt6"};